export const SET_ADDRESS_DETAILS = "SET_ADDRESS_DETAILS";
export const UNSET_ADDRESS_DETAILS = "UNSET_ADDRESS_DETAILS";
export const SET_ADDRESS_ISLAND_STATUS = "SET_ADDRESS_ISLAND_STATUS";

export const SET_REGISTRY_ADDRESS_DETAILS = "SET_REGISTRY_ADDRESS_DETAILS";
export const SET_MANUAL_ADDRESS_DETAILS = "SET_MANUAL_ADDRESS_DETAILS";
export const SET_ADDRESS_TYPE = "SET_ADDRESS_TYPE";
